import React from "react";

import { Container, Content } from "./styles";

export default function Popover({
  icon = null,
  direction = "row",
  text,
  color = 'var(--white)',
  bgColor = 'var(--form-black)',
  children,
  fontStyle = 'italic',
  ...rest
}) {
  return (
    <Container direction={direction} {...rest}>
      <div>
        {icon}
        {children}
        <Content fontStyle={fontStyle} color={color} bgColor={bgColor}>{text}</Content>
      </div>
    </Container>
  );
}
